/** @format */

import React from "react";
// Customizable Area Start
import { withStyles, Theme } from "@material-ui/core/styles";
import {
  Dialog,
  Typography,
  Button,
  Avatar,
  ListItem,
  ListItemText,
  Box,
  TextareaAutosize,
  OutlinedInput,
} from "@material-ui/core";
import { colors } from "../../../blocks/utilities/src/Colors";
import { CustomMenuUpchargeDrop } from "../../../blocks/cfplantdashboard2/src/utils";
import { styled, Styles } from "@material-ui/styles";
import {
  sortCondition,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import PreferenceItemController, {
  Props,
  Options,
} from "./PreferenceItemController.web";
import CustomRadioDropdown from "./CustomDropdownRadioSelect.web";
import {
  checkedIcon,
  unCheckedIcon,
  openCircle,
  filledCircle,
} from "../../../blocks/ProductDescription/src/assets";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import { CustomSearchableMultiSelect } from "../customComponent/CustomSearchableMultiSelect.web";
import {
  TableRow,
  TableCell,
  OrderTable,
  RowContainer,
} from "../../../components/src/OrderTable/src";
import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";
export const configJSON = require("../config");
// Customizable Area End

// Customizable Area Start
const StyledMenuItemPreference = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: "#204B9C",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export const styles: Styles<Theme, {}, string> = () => ({
  mainDialog: {
    "& .MuiDialog-paper": {
      maxWidth: "unset !important",
      borderRadius: 24,
    },
  },
  headerTitle: {
    textAlign: "center",
    marginTop: "20px",
    fontSize: "1.6rem",
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: 10,
    border: "1px solid #ccc",
    margin: 20,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    width: "90vw",
  },
  mainContainerInner: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  topPartContainer: {
    display: "flex",
    marginLeft: 20,
    marginTop: 32,
  },
  headerListSec: {
    display: "grid",
    gridTemplateColumns: "repeat(5,1fr)",
    padding: "20px 50px",
    gridGap: "40px",
    marginLeft: 10,
    ["& h6"]: {
      fontWeight: 600,
      fontSize: 18,
      color: "#FFFFFF",
    },
  },
  selectedProduct: {
    display: "flex",
    alignItems: "center",
    marginTop: 30,
    ["& p"]: {
      fontWeight: 600,
    },
  },
  dropDownSelection: {
    padding: "0px 30px",
    margin: 20,
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: 12,
    position: "relative",
  },
  radioDropdown: {
    paddingTop: 16,
    display: "grid",
    gap: 20,
    gridTemplateColumns: "repeat(4,1fr)",
    "&:empty": {
      paddingTop: 0
    },
    "@media screen and (max-width: 1550px)": {
      gridTemplateColumns: "repeat(3,1fr)",
    },
    "@media screen and (max-width: 1200px)": {
      gridTemplateColumns: "repeat(2,1fr)",
    },
    "@media screen and (max-width: 800px)": {
      gridTemplateColumns: "1fr",
    },
  },
  upchargeSection: {
    display: "flex",
    margin: "30px 0",
  },
  radioSection: {
    display: "flex",
    margin: "30px 0",
    alignItems: "center",
    "@media (max-width: 1000px)": {
      alignItems: "flex-start",
      ["& p"]: {
        marginTop: 10,
      },
    },
  },
  header: {
    padding: "10px",
    color: "#1A1A1A",
    fontWeight: 600,
    fontSize: 14,
  },
  semiColon: {
    marginLeft: 20,
    color: "#1A1A1A",
    fontWeight: 600,
    fontSize: 14,
  },
  checkboxDetail: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gridGap: 10,
    "@media (max-width: 1000px)": {
      gridTemplateColumns: "repeat(1,1fr)",
    },
  },
  checkboxList: {
    cursor: "pointer",
    paddingTop: 0,
  },
  checkboxInner: {
    display: "flex",
    alignItems: "center",
    padding: "6px 20px",
    borderRadius: 12,
    marginLeft: 10,
    width: 300,
    textAlign: "right",
  },
  radioInner: {
    width: "unset",
  },
  checkboxInnerChecked: {
    background: "#F1F5F9",
    color: "#204B9C",
    border: "1px solid #ECECEC",
  },
  checkboxInnerUnChecked: {
    border: "1px solid #ECECEC",
    background: "#FFFFFF",
  },
  radioBox: {
    display: "flex",
    flexWrap: "wrap",
    cursor: "pointer",
    "@media (max-width: 1000px)": {
      flexDirection: "column",
    },
    "& .MuiListItem-root": {
      width: "auto",
    },
  },
  closeIcon: {
    position: "absolute",
    right: 0,
    top: 0,
    cursor: "pointer",
    color: "#4D4D4D",
  },
  textItem: {
    marginLeft: 15,
    textAlign: "left",
    width: 150,
  },
  iConSize: {
    width: 20,
    height: 20,
    borderRadius: "unset",
  },
  imageSize: {
    width: 24,
    height: 24,
    borderRadius: "unset",
  },
  chnageImageColor: {
    filter: "sepia(100%) saturate(600%) hue-rotate(195deg)",
  },
  checkboxListColor: {
    color: "#204B9C",
    cursor: "pointer",
  },
  addMore: {
    display: "flex",
    alignItems: "center",
    color: "#204b9c",
    cursor: "pointer",
    margin: 20,
    ["& button"]: {
      textTransform: "capitalize",
      fontWeight: 600,
    },
  },
  addMoreButton: {
    color: "#204b9c",
    ["&:hover"]: {
      color: "#204b9c",
      background: "#ffffff",
    },
  },
  groupButton: {
    margin: "30px auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
    ["& button"]: {
      textTransform: "capitalize",
      padding: "18px 35px",
      fontWeight: 600,
      fontSize: 16,
      borderRadius: 8,
      width: 185,
    },
  },
  cancelButton: {
    color: "#64748b",
    background: "#f1f5f9",
    marginRight: 20,
    ["&:hover"]: {
      backgroundColor: "#f1f5f9",
    },
  },
  addButton: {
    color: "#ffffff",
    background: "#204b9c",
    ["&:hover"]: {
      backgroundColor: "#204b9c",
    },
  },
  errorBox: {
    display: "flex",
  },
  errorColor: {
    color: "red",
  },
  inputFieldNote: {
    display: "flex",
    borderRadius: 8,
    border: "1px solid #ECECEC",
    background: "#f8f8f8",
    padding: 8,
    marginBottom: 15,
    width: "100%",
  },

  saveCheckbox: {
    display: "flex",
  },
  textgroup: {
    display: "flex",
    cursor: "pointer",
  },
  futureGroup: {
    marginTop:"10px",
    flexBasis: "85%",
  },
  imageSizeSave: {
    width: 20,
    height: 20,
    borderRadius: "unset",
    marginRight: 15,
  },
  topTitle: {
    color: "#334155",
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: 4,
  },
  topTextContainer: {
    padding: "10px 16px",
    borderRadius: "8px",
    background: "#E9E9E9",
    fontSize: 16,
    fontWeight: 500,
    height: 56,
    width: 364,
    display: "flex",
    alignItems: "center",
  },
  selectContainer: {
    height: "auto",
    marginTop: 16,
    "& .MuiSelect-outlined": {
      whiteSpace: "nowrap !important",
      wordBreak: "break-word !important"
    },
    "& .MuiTypography-displayBlock": {
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
});
const SelectCustomRow = styled("div")({
  "& .wrapper-componenetZ .MuiAutocomplete-root":{
paddingTop:"0",
  },
  "& .wrapper-componenetZ .MuiAutocomplete-inputRoot":{
    padding:"6px",
  },
  "& .fieldSpecifications": {
    overflow: "hidden",
    display: "flex",
    height: "49px",
    alignItems: "center",
    position:"relative"
  },
  "& .selected-items + input": {
    width: "0",
    height: "0",
    margin: "0",
    border: "none",
    opacity: 0,
    pointerEvents: "none",
    padding: "0", 
  },
  "& .selected-items":{
    position:"absolute",
    overflow: "hidden",
  textOverflow: "ellipsis",
  display: "inline-block",
  width: "100px",
  whiteSpace: "nowrap",
  },
  width:"100%",
  "& .MuiAutocomplete-root":{
minWidth:"100%",
padding:"6px",
  },
  "& .wrapper-componenet .MuiInputBase-root":{
    paddingTop:"0px"
  },
  "& .fieldSpecifications .MuiInputBase-root":{
    padding: "5.5px 4px",
    minHeight: "48px"
  }
})
const CustomSelect = styled(Select)({
  padding: "10px 8px",
  borderRadius: "8px",
  border: `1px solid ${colors().lightborder}`,
  fontSize: "12px",
  fontWeight: 400,
  background: colors().white,
  fontFamily: "Montserrat",
  width: "100%",
  height: "49px",
  "&:focus": {
    borderRadius: "8px",
    borderColor: colors().cyancobaltblue,
    outline: "none",
  },
});
const UpchargeSelectMenuItem = styled(MenuItem)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: "8px",
  paddingBottom: "8px",
  whiteSpace: "normal",
  "&.MuiListItem-root.Mui-selected": {
    backgroundColor: `${colors().brightgray} !important`,
  },
  "& .upcharge-content": {
    display: "flex",
    alignItems: "flex-start",
  },
  "& .upcharge-content-box": {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    flexWrap: "wrap",
  },
  "& .upcharge-main-item": {
    display: "flex",
    alignItems: "flex-start",
  },
  "& .upchargeName": {
    fontSize: "15px",
    fontFamily: "Montserrat",
  },
  "& .upchargeActiveName": {
    fontSize: "15px",
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
  },
  "& .dropdownUpchargeName": {
    fontSize: "14px",
    fontFamily: "Montserrat",
  },
  "& .dropdownUpchargeActiveName": {
    fontSize: "14px",
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
  },
  "& .upchargeIcon": {
    minWidth: "18px",
    maxWidth: "18px",
    minHeight: "18px",
    maxHeight: "18px",
    borderRadius: "4px",
    margin: "0 8px",
  },
  "& .d-flex": {
    display: "flex",
    alignItems: "center",
  },
  "& .upcharge-name": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    fontFamily: "Montserrat",
    margin: "0 0 0 8px",
  },
  "& .ml-8": {
    margin: "0 0 0 8px",
  },
});
// Customizable Area End

class PreferenceItem extends PreferenceItemController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  // Customizable Area Start
  handleUpchargeSelectionChange = (selectedIds: any[], order_items_preference_id: any) => {
    this.setState(prevState => {
      const updatedUpcharges = prevState.preferenceStateData?.attributes?.upcharges?.map((item: any) => ({
        ...item,
        checked: selectedIds.includes(item.id),
      }));
  
      return {
        upchargeSelections: {
          ...prevState.upchargeSelections,
          [order_items_preference_id]: selectedIds,
        },
        preferenceStateData: {
          ...prevState.preferenceStateData,
          attributes: {
            ...prevState.preferenceStateData.attributes,
            upcharges: updatedUpcharges,
          },
        },
      };
    }, () => {
      console.log(
        this.state.upchargeSelections,
        this.state.preferenceStateData,
        selectedIds,
        order_items_preference_id,
        "Updated selections"
      );
    });
  };
  
  isUpchargeSelected = (upchargeId:any, order_items_preference_id:any) => {
    const selArr = this.state.upchargeSelections[order_items_preference_id] || [];
    return selArr.includes(upchargeId);
  };
  handlePreferenceSelect = (selectedId:any) => {
    this.setState(prevState => {
      const preferences = prevState.preferenceStateData?.attributes?.preferences || [];
      const updatedPreferences = preferences.map((item:any) => ({
        ...item,
        checked: item.id.toString() === selectedId
      }));
      return {
        preferenceStateData: {
          ...prevState.preferenceStateData,
          attributes: {
            ...prevState.preferenceStateData.attributes,
            preferences: updatedPreferences,
          }
        }
      };
    });
  };
  getSelectedPreferenceObject = () => {
    const preferences = this.state.preferenceStateData?.attributes?.preferences || [];
    const checkedPref = preferences.find((item:any) => item.checked);
    return checkedPref
      ? { id: checkedPref.id.toString(), option: checkedPref.name }
      : null;
  };
  renderPreferenceBody(preferenceData:any) {
    const preferences_list = preferenceData.attributes.preferences;
    const selectedItem = this.state.preferenceStateData?.attributes?.preferences.find((item: any) => item.checked);
    const value = selectedItem ? selectedItem.id.toString() : "";
    return (
      <SelectCustomRow>
        <div className="wrapper-componenetZ">
          <AutocompleteSelect
            data-test-id="preferenceDropdown"
            fieldName="preference"
            placeholder="Select Preference"
            listBoxStyle={{ maxHeight: 270 }}
            options={preferences_list.map((pref: any) => ({
              id: pref.id.toString(), 
              option: pref.name,
            }))}
            value={value} 
            onChange={(
              event: any,
              selectedValue: any
            ) => {
              if (selectedValue) {
                this.handlePreferenceSelect(selectedValue.id.toString());
              }
            }}
          />
        </div>
      </SelectCustomRow>
    );
  }
  renderUpchargeBody(preferenceData:any) {
    const upcharges = preferenceData?.attributes?.upcharges || [];
    const rowId = preferenceData?.order_items_preference_id || "default";
    const selectedIds = this.state.upchargeSelections[rowId] || [];
    return (
      <SelectCustomRow>
        <Box className="bottom-upcharge-select-wrap">
          <CustomSelect
            multiple
            displayEmpty
            value={selectedIds}
            onChange={event =>
              this.handleUpchargeSelectionChange(event.target.value as number[], rowId)
            }
            input={<OutlinedInput />}
            renderValue={(selected: any) => {
              const selectedUpcharges = upcharges.filter((item:any) =>
                selected.includes(item.id)
              );

              if (selectedUpcharges.length === 0) return 'See all upcharges';

              const firstName = selectedUpcharges[0].name.trim();
              const suffix = selectedUpcharges.length > 1 ? '...' : '';

              return `${firstName}${suffix}`;
            }}
            MenuProps={CustomMenuUpchargeDrop}
          >
            {upcharges.map((upcharge:any) => (
              <MenuItem key={upcharge.id} value={upcharge.id}>
                <img
                  src={
                    this.isUpchargeSelected(upcharge.id, rowId)
                      ? checkedIcon
                      : unCheckedIcon
                  }
                  style={{ width: 18, height: 18, marginRight: 8 }}
                  alt="check"
                />
                <img
                  src={upcharge.icon}
                  style={{ width: 24, height: 24, marginRight: 8 }}
                  alt=""
                />
                <span>{upcharge.name}</span>
                <span style={{ marginLeft: 8 }}>
                  {upcharge.currency} {Number(upcharge.price).toFixed(2)}
                </span>
              </MenuItem>
            ))}
          </CustomSelect>
        </Box>
      </SelectCustomRow>
    );
  }
  renderSpecificationBody(
    preferenceData: any,
    specification: any,
    specification_index: number
  ) {
    const optionList = this.getSpecificationOptionList(
      preferenceData.options_attributes
    );
  
    const value: any = optionList.filter((option: any) =>
      (this.state.selectedOptions[specification_index]?.option_id || []).includes(option.id)
    );
  
    return (
      <SelectCustomRow data-test-id="specification-dropdowns">
         <div className="fieldSpecifications">
         <CustomSearchableMultiSelect
        id="specification"
        name="specification"
        dropdownStyle={{ width: '300px',maxWidth:"300px" }}
        dataTestId={`field-specifications-${preferenceData.id}-${specification}`}
        value={value}
        optionList={optionList}
        placeHolderText={`Select ${specification}`}
        handleSelectOptions={(value:any, option:any) =>
          this.handleOnSelectSpecification(specification_index, option.id)
        }
        selectedOptionForList={value}
        emptyDataMessage="No data found"
        keepSelectAll={false}
        checkSelectAllText={() => {}}
        changeInputOnClear
        handleScroll={() => {}}
        handleClickOnSelectAll={() => {}}
        debouncedFunction={(getValue:any) => {
          if (getValue === '') this.handleClearMultiSelect();
        }}
        handleEmptyAutoSelectValue={() => {}}
        //@ts-ignore
        renderTags={(selectedItems) => (
          <span className="selected-items">
            {selectedItems.slice(0, 1).map((item: any) => item.option).join(', ')}
            {selectedItems.length > 1 ? '...' : ''}
          </span>
        )}
      />
         </div>
      </SelectCustomRow>
    );
  }
  
  renderSelectedLabel = (value: string, item: any | undefined ) => {
    if (!value) {
      return <Typography style={{ color: 'grey', textOverflow: 'ellipsis', overflow: 'hidden'}}>{`Select ${item?.name}`}</Typography>;
    }
    const selectedOptionIndex = item?.options_attributes.findIndex((option:{id: string}) => option.id.toString() == value);
    const optionLabel = (selectedOptionIndex !== undefined && selectedOptionIndex !== -1) ? item?.options_attributes[selectedOptionIndex].label : '';
    return optionLabel
  }

  renderLastPreference = (index?: number) => {
    const { classes, preferenceData, selectedService } = this.props;
    const { selectedOptions } = this.state;

    if (index === undefined) index = 0;
    return (
      <>
        <div className={classes.topPartContainer}>
          <div style={{ marginRight: 32 }}>
            <div className={classes.topTitle}>Product</div>
            <div className={classes.topTextContainer}>
              {preferenceData?.attributes?.name}
            </div>
          </div>
          <div>
            <div className={classes.topTitle}>Service</div>
            <div className={classes.topTextContainer}>
              {selectedService?.name}
            </div>
          </div>
        </div>
        <Box>
          <Box className={classes.mainContainer}>
            <Box className={classes.mainContainerInner}>
              <OrderTable>
              <RowContainer header>
              <TableRow columns={"repeat(auto-fit, minmax(150px, 1fr))"}>
              <TableCell
    key="Preference"
    header
    content="Preference"
  />
  { preferenceData?.attributes?.specifications?.map((item: any) => (
    <TableCell
    style={{textAlign:"center"}}
      key={item.name}
      header
      content={item.name}
    />
  ))}
   <TableCell
    key="Upcharge"
    header
    content="Upcharge"
  />
</TableRow>
              </RowContainer>
               <RowContainer key={index}>
                  <TableRow columns={"repeat(auto-fit, minmax(150px, 1fr))"}>
    {preferenceData?.attributes?.upcharges &&
      <TableCell content={this.renderPreferenceBody(preferenceData)} />
    }
      {preferenceData?.attributes?.specifications?.map((spec: any, specIndex: number) => (
        <TableCell content={this.renderSpecificationBody(spec,spec.name, specIndex)} />
      ))}
      <TableCell
             style={{display:"flex", width:"100%"}}
        content={
          preferenceData?.attributes?.upcharges && preferenceData?.attributes?.upcharges.length > 0
            ? this.renderUpchargeBody(preferenceData)
            : <div style={{fontSize:"12px",display:"flex", alignItems:"center", width:"100%", height:"100%"}}>No upcharge found</div>
        }
      />
    </TableRow>
  </RowContainer>
              </OrderTable>
            </Box>
            <Box className={classes.dropDownSelection}>
              <Box className={classes.saveCheckbox}>
                <Box className={classes.futureGroup}>
                  <TextareaAutosize
                    className={classes.inputFieldNote}
                    placeholder='Add Note'
                    value={
                      this.state.preferenceStateData?.attributes?.notes || ""
                    }
                    onChange={(event) => {
                      this.setState({
                        preferenceStateData: {
                          ...this.state.preferenceStateData,
                          attributes: {
                            ...this.state.preferenceStateData?.attributes,
                            notes: event.target.value,
                          },
                        },
                      });
                    }}
                    rows={2}
                    rowsMax={6}
                  />
                  <Box
                    style={{ marginBottom: 16 }}
                    onClick={() =>
                      this.setState({
                        preferenceStateData: {
                          ...this.state.preferenceStateData,
                          attributes: {
                            ...this.state.preferenceStateData?.attributes,
                            save_for_future: !this.state.preferenceStateData
                              ?.attributes?.save_for_future,
                          },
                        },
                      })
                    }
                  >
                    <Typography className={classes.textgroup}>
                      <Avatar
                        className={classes.imageSizeSave}
                        src={
                          this.state.preferenceStateData?.attributes
                            ?.save_for_future
                            ? checkedIcon
                            : unCheckedIcon
                        }
                        alt='Checked'
                      />
                      Save for future
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    );
  };
  render() {
    const { classes, open, editable, headerTitle, handleClose } = this.props;

    return (
      <Dialog open={open} className={classes.mainDialog}>
        <Typography className={classes.headerTitle} variant='h4'>
          {headerTitle}
        </Typography>

        {this.renderLastPreference()}

        <Box className={classes.groupButton}>
          <Button
            onClick={handleClose}
            disableRipple
            className={classes.cancelButton}
          >
            Cancel
          </Button>
          <Button
            data-test-id='btn-submit-preference'
            disableRipple
            onClick={this.handleCreateClick}
            className={classes.addButton}
          >
            {editable ? "Save" : "Create"}
          </Button>
        </Box>
      </Dialog>
    );
  }
  // Customizable Area End
}
export default withStyles(styles)(PreferenceItem);

